import { render, staticRenderFns } from "./wf-text-area-display.vue?vue&type=template&id=e4baa65a&scoped=true&"
import script from "./wf-text-area-display.vue?vue&type=script&lang=ts&"
export * from "./wf-text-area-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-text-area-display.vue?vue&type=style&index=0&id=e4baa65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4baa65a",
  null
  
)

export default component.exports